import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { fetchExternalLinks as fetchExternalLinksService } from '../../../../services/external-links-fetch-service';
import type { State, Props } from '../../types';

export const EVENT_NAME = 'externalResourcesFetch';
export const fetchExternalLinks =
	() =>
	async ({ getState, setState }: StoreActionApi<State>, props: Props) => {
		const { cloudId, projectId, createAnalyticsEvent } = props;
		try {
			setState({
				...getState(),
				links: {
					data: [],
					isLoading: true,
					error: null,
					totalSize: 0,
				},
			});

			const { links, total } = await fetchExternalLinksService(cloudId, projectId);
			setState({
				...getState(),
				links: {
					data: links,
					isLoading: false,
					error: null,
					totalSize: total,
				},
			});

			fireOperationalAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} succeeded`);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			let errorState = error;
			/**
			 * Send experience failure events only when fetch external links API call responds
			 * with a status of 5xx or 404.
			 */
			if (`${error.statusCode}`.startsWith('5') || error.statusCode === 404) {
				fireOperationalAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} failed`);
			} else {
				errorState = null;
			}

			setState({
				...getState(),
				links: {
					data: [],
					error: errorState,
					isLoading: false,
					totalSize: 0,
				},
			});
		}
	};
